import organizationTypes from "astrid-firestore/src/api/organizations/constants/organizationTypes";

import { getItem, setItem } from "../../../../../utils/localStorage";

const VISIBLE_COLUMNS_KEY = "productions.visibleColumns";

function getDefaultVisibleColumns({ organization }) {
	switch (organization?.type) {
		case organizationTypes.PUBLISHER:
			return [
				"status",
				"title",
				"series",
				"author",
				"progressBar",
				"productionType",
				"publisherManagerNames",
				"deliveryDate",
			];

		case organizationTypes.PRODUCER:
			return [
				"status",
				"title",
				"series",
				"author",
				"publisherName",
				"progressBar",
				"productionType",
				"noOfCorrections",
				"deliveryDate",
				"productionDate",
			];

		default:
			return undefined;
	}
}

export default function useProductionsVisibleColumns({ organization }) {
	const defaultVisibleColumns = getDefaultVisibleColumns({ organization });
	const visibleColumns = getItem(VISIBLE_COLUMNS_KEY) || defaultVisibleColumns;

	function setVisibleColumns(visibleColumns) {
		setItem(VISIBLE_COLUMNS_KEY, visibleColumns);
	}

	return [visibleColumns, setVisibleColumns, defaultVisibleColumns];
}
